import React from "react";
import { Tag } from "antd";
const DirectBrokerageTag = ({ bold }) => (React.createElement(Tag, { color: "processing", style: { fontWeight: bold ? "bold" : "normal" } }, "Direct Brokerage"));
DirectBrokerageTag.defaultProps = {
    bold: false,
};
export default DirectBrokerageTag;
